<template>
  <div v-if="currentAnswerSet && selectedQuestion" style="padding:1rem;">
    <div class="columns">
      <div class="column b-portlet">
        <div class="b-portlet-header">
          <div class="columns">
            <div class="column">
              <div class="content">
                <h3 class="is-marginless">
                  {{ currentAnswerSet.process.name }} ({{ selectedQuestion.no }}/{{
                    questionCount
                  }})
                  <button ref="focusButton" style="margin-left:-1500px;"></button>
                </h3>
              </div>
            </div>
            <div class="column is-2">
              <b-field class="is-pulled-right" grouped>
                <b-tooltip
                  class="control"
                  :label="$t('button.keep') + ' ' + $t('button.continueLater')"
                  position="is-bottom"
                  multilined
                >
                  <button class="button is-light" @click="saveAndContinueLater">
                    {{ $t('button.keep') }}
                  </button>
                </b-tooltip>

                <b-tooltip
                  v-if="previousAnswerSet"
                  class="control"
                  :label="previousAnswerSet.process.name"
                  position="is-bottom"
                  multilined
                >
                  <b-button
                    class="button is-info"
                    icon-pack="fas"
                    icon-left="chevron-left"
                    @click="previousProcess"
                  >
                    {{ $t('button.previous') }} {{ $t('title.process') }}
                  </b-button>
                </b-tooltip>
                <b-tooltip
                  v-if="nextAnswerSet"
                  class="control"
                  :label="nextAnswerSet.process.name"
                  position="is-bottom"
                  multilined
                >
                  <b-button
                    class="button is-info"
                    icon-pack="fas"
                    icon-left="chevron-right"
                    @click="nextProcess"
                  >
                    {{ $t('button.next') }} {{ $t('title.process') }}
                  </b-button>
                </b-tooltip>
                <b-tooltip
                  v-if="!nextAnswerSet || allQuestionAnswered"
                  class="control"
                  :label="$t('button.finishSurvey') + ' ' + $t('button.calculateOnlineAuditScore')"
                  position="is-bottom"
                  multilined
                >
                  <button class="button is-success" @click="nextProcess(true)">
                    {{ $t('button.finishSurvey') }}
                  </button>
                </b-tooltip>
              </b-field>
            </div>
          </div>
        </div>
        <div class="b-portlet-body">
          <div class="content">
            <div class="box">
              <div class="media-content">
                <div class="content">
                  <h5>{{ selectedQuestion.name }}</h5>
                </div>
              </div>
            </div>
            <div class="notification" v-if="selectedQuestion.description">
              <table>
                <tr>
                  <td style="border:none !important; width:10px;">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      x="0px"
                      y="0px"
                      width="20"
                      height="20"
                      viewBox="0 0 40 40"
                      style=" fill:#000000; margin:3px;"
                    >
                      <path
                        fill="#98ccfd"
                        d="M20,38.5C9.799,38.5,1.5,30.201,1.5,20S9.799,1.5,20,1.5S38.5,9.799,38.5,20S30.201,38.5,20,38.5z"
                      />
                      <path
                        fill="#4788c7"
                        d="M20,2c9.925,0,18,8.075,18,18s-8.075,18-18,18S2,29.925,2,20S10.075,2,20,2 M20,1 C9.507,1,1,9.507,1,20s8.507,19,19,19s19-8.507,19-19S30.493,1,20,1L20,1z"
                      />
                      <path fill="#fff" d="M20 10A2 2 0 1 0 20 14A2 2 0 1 0 20 10Z" />
                      <g>
                        <path
                          fill="#fff"
                          d="M22 29L22 17 17 17 17 18 18 18 18 29 17 29 17 30 23 30 23 29z"
                        />
                      </g>
                    </svg>
                  </td>
                  <td style="border:none !important;">{{ selectedQuestion.description }}</td>
                </tr>
              </table>
            </div>
            <p></p>
            <b-field>
              <b-input
                :placeholder="$t('description.processQuestionDescriptionPlaceholder')"
                v-model="selectedQuestion.answerDescription"
                type="textarea"
                rows="2"
                name="description"
                expanded
            /></b-field>
            <photo-upload
              ref="photoUpload"
              v-model="selectedQuestion.photos"
              :question-id="selectedQuestion.id"
              :answer-set-id="currentAnswerSet.id"
              @deleted="onPhotoDeleted"
            />
            <div>
              <b-field :class="'is-grouped is-grouped-centered'" :key="answerFieldsKey">
                <b-button
                  v-for="pointData of pointDataList"
                  :ref="`answerButton_${pointData.point}`"
                  :key="pointData.point"
                  :size="`is-medium ${pointData.class}`"
                  style="margin-right:8px"
                  :outlined="hasAnswerOutline(pointData.point)"
                  @click="saveAnswer(pointData.point, selectedQuestion.answerDescription)"
                  >{{ pointData.point }}</b-button
                >
              </b-field>
            </div>
          </div>
        </div>

        <div class="b-portlet-footer">
          <b-pagination
            :total="questionCount"
            :current.sync="selectedQuestion.no"
            :range-before="3"
            :range-after="1"
            :order="'is-centered'"
            :simple="false"
            :rounded="true"
            :per-page="1"
            :icon-prev="'arrow-left'"
            :icon-next="'arrow-right'"
            aria-next-label="Sonraki soru"
            aria-previous-label="Önceki soru"
            aria-page-label="Soru"
            aria-current-label="Şu andaki soru"
            @change="changeQuestion"
          ></b-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from '../../_api/api.service'
import PhotoUpload from './PhotoUpload.vue'

export default {
  props: ['process'],
  components: {
    PhotoUpload
  },
  data () {
    return {
      currentAnswerSetIndex: 0,
      selectedQuestion: null,
      answerSetGroup: null,
      allQuestionAnswered: false,
      pointDataList: [
        { point: 0, class: 'is-danger' },
        { point: 1, class: 'is-orange' },
        { point: 2, class: 'is-gray' },
        { point: 3, class: 'is-info' },
        { point: 4, class: 'is-success' }
      ],
      answerFieldsKey: 'answerFields'
    }
  },
  computed: {
    ...mapGetters(['role']),
    currentAnswerSet () {
      if (!this.answerSetGroup) {
        return null
      }
      return this.answerSetGroup.answerSets[this.currentAnswerSetIndex]
    },
    previousAnswerSet () {
      if (!this.answerSetGroup || this.currentAnswerSetIndex === 0) {
        return null
      }
      return this.answerSetGroup.answerSets[this.currentAnswerSetIndex - 1]
    },
    nextAnswerSet () {
      if (
        !this.answerSetGroup ||
        this.currentAnswerSetIndex === this.answerSetGroup.answerSets.length - 1
      ) {
        return null
      }
      return this.answerSetGroup.answerSets[this.currentAnswerSetIndex + 1]
    },
    questionCount () {
      if (!this.answerSetGroup) {
        return 0
      }
      return this.answerSetGroup.answerSets[this.currentAnswerSetIndex].process.questions.length
    }
  },
  mounted () {
    this.getAnswerSetGroup()
  },
  methods: {
    hasAnswerOutline (point) {
      if (this.selectedQuestion && this.selectedQuestion.answer === point) {
        return false
      } else {
        return true
      }
    },
    changeQuestion (no) {
      if (no > this.questionCount) return
      const question = this.currentAnswerSet.process.questions[no - 1]
      // Reloading the question on screen would drop its unsaved description and photos.
      // Question ids are unique across processes, so a process change always reloads
      if (this.selectedQuestion && this.selectedQuestion.id === question.id) return
      this.selectedQuestion = { ...question }
    },
    saveAndContinueLater () {
      this.$buefy.dialog.alert(this.$t('description.saveAndContinueLaterDialog'))
    },
    previousProcess () {
      this.currentAnswerSetIndex = this.currentAnswerSetIndex - 1
      this.changeQuestion(this.currentAnswerSet.process.questions.length)
    },
    nextProcess (finished = false) {
      const notAnsweredQuestions = this.currentAnswerSet.process.questions.filter(
        q => q.answer == null && q.answer !== 0
      )
      if (notAnsweredQuestions.length > 0) {
        const notAnsweredQuestionNumbers = notAnsweredQuestions.map(q => q.no)
        const notAnsweredQuestionNumbersText = notAnsweredQuestionNumbers.join(',')
        this.$buefy.dialog.alert(
          `${this.$t('description.notAnsweredQuestionsAlert')}<br><br> ${this.$t(
            'title.notAnsweredQuestions'
          )}: ${notAnsweredQuestionNumbersText}`
        )
        this.changeQuestion(notAnsweredQuestionNumbers[0])
      } else {
        if (finished === true) {
          ApiService.put(`/answerset/group/${this.answerSetGroup.id}/close`, {
            website: this.$t('title.websiteName'),
            sendEmail: true
          }).then(data => {
            this.score = data
            this.$emit('setScore', data)
            this.$emit('next')
            this.$buefy.dialog.alert({
              message: this.$t('description.processFinished'),
              confirmText: this.$t('button.ok')
            })
          })
        } else {
          this.currentAnswerSetIndex = this.currentAnswerSetIndex + 1
          const notAnsweredQuestionNumbers = this.currentAnswerSet.process.questions
            .filter(q => q.answer == null && q.answer !== 0)
            .map(q => q.no)
          const currentQuestionNo =
            notAnsweredQuestionNumbers.length > 0
              ? notAnsweredQuestionNumbers[0]
              : this.currentAnswerSet.process.questions.length
          this.changeQuestion(currentQuestionNo)
        }
      }
    },
    async getAnswerSetGroup () {
      const processId = this.process.processes[0].id
      try {
        this.answerSetGroup = await ApiService.get(
          `/answerset/group/current/${processId}/${this.process.processGroup.id}`
        )
        this.setCurrentQuestion(this.answerSetGroup)
      } catch (error) {
      // eslint-disable-next-line no-console
        console.log(error)
        this.$emit('skip', 1)
      }
    },
    setCurrentQuestion (answerSetGroup) {
      let currentProcessActiveQuestion = 0
      let answerSetCurentIndexCompleted = false
      answerSetGroup.answerSets.forEach((answerSet, answerSetIndex) => {
        answerSet.answers.forEach(a => {
          answerSet.process.questions.forEach(q => {
            if (q.id === a.questionId) {
              q.answer = a.answerPoint
              q.answerDescription = a.description
              q.photos = Array.isArray(a.photos) ? a.photos : []
            }
          })
        })
        if (answerSetCurentIndexCompleted === false) {
          if (
            answerSet.answers.length < answerSet.process.questions.length ||
            answerSetGroup.answerSets.length === 1 ||
            answerSetGroup.answerSets.length === answerSetIndex + 1
          ) {
            answerSetCurentIndexCompleted = true
            const unansweredQuestionIndex = answerSet.process.questions.findIndex(
              q => q.answer == null
            )
            if (unansweredQuestionIndex > -1) {
              currentProcessActiveQuestion = unansweredQuestionIndex
            } else {
              currentProcessActiveQuestion = answerSet.process.questions.length - 1
            }
          } else if (
            answerSet.process.questions.length === answerSet.answers.length &&
            answerSetGroup.answerSets.length > 1
          ) {
            this.currentAnswerSetIndex = this.currentAnswerSetIndex + 1
          }
        }
      })
      // A copy, like changeQuestion, so unsaved edits never reach the saved answers
      this.selectedQuestion = { ...this.currentAnswerSet.process.questions[currentProcessActiveQuestion] }
    },
    refreshAnswerFields () {
      this.answerFieldsKey = 'answerFields' + Math.random()
    },
    saveAnswer (answer, description) {
      if (!this.$refs.photoUpload.canSave()) return
      const { focusButton } = this.$refs
      focusButton.focus()
      // The user may change the question or the process before the request ends, so the
      // saved answer is the one taken here
      const question = this.selectedQuestion
      const answerSet = this.currentAnswerSet
      const photos = question.photos || []
      const request = ApiService.post('/answer', {
        answerPoint: parseInt(answer),
        description: description,
        questionId: question.id,
        answerSetId: answerSet.id,
        processId: answerSet.processId,
        photos
      })
      this.$refs.photoUpload.trackSave(request, photos)
      request
        .then(() => {
          const savedQuestion = answerSet.process.questions[question.no - 1]
          savedQuestion.answer = answer
          savedQuestion.answerDescription = question.answerDescription
          savedQuestion.photos = photos

          if (this.currentAnswerSet.process.questions.length > this.selectedQuestion.no) {
            const nextQuestionNo = this.selectedQuestion.no + 1
            this.changeQuestion(nextQuestionNo)
          } else if (
            this.currentAnswerSet.process.questions.length === this.selectedQuestion.no &&
            this.answerSetGroup.answerSets.length > this.currentAnswerSetIndex + 1
          ) {
            this.nextProcess()
          } else {
            // The selected question is a copy, so the answer buttons would not show the answer
            if (this.selectedQuestion.id === question.id) {
              this.$set(this.selectedQuestion, 'answer', answer)
            }
            this.refreshAnswerFields()
          }

          if (!this.allQuestionAnswered) {
            let isAllQuestionAnswered = true
            this.answerSetGroup.answerSets.forEach(answerSet => {
              const hasNotAnsweredQuestion = answerSet.process.questions.some(
                q => q.answer == null && q.answer !== 0
              )
              if (hasNotAnsweredQuestion) {
                isAllQuestionAnswered = false
              }
            })

            if (isAllQuestionAnswered) {
              this.$buefy.dialog.confirm({
                message: this.$t('description.allQuestionsAnswered'),
                confirmText: this.$t('button.calculateScore'),
                cancelText: this.$t('button.turnBack'),
                canCancel: true,
                onConfirm: () => this.nextProcess(true)
              })
              this.allQuestionAnswered = true
            }
          }
        })
        .catch(() => {
          answerSet.process.questions[question.no - 1].answer = null
        })
    },
    onPhotoDeleted ({ url, questionId, answerSetId }) {
      const answerSet = this.answerSetGroup.answerSets.find(s => s.id === answerSetId)
      const savedQuestion = answerSet && answerSet.process.questions.find(q => q.id === questionId)
      if (savedQuestion && savedQuestion.photos) {
        savedQuestion.photos = savedQuestion.photos.filter(photo => photo !== url)
      }
    }
  }
}
</script>
